<template>
  <div
    class="quiz-result-modal"
    @click="$emit('onClick')"
  >
    <div class="quiz-result-wrapper">
      <div v-if="isCorrect" class="quiz-result-background">
        <lottie
          :options="quizResultBackgroundOptions"
          :height="300"
          :width="300"
        />
      </div>
      <div class="quiz-result-content">
        <lottie
          :options="quizIconOptions"
          :height="80"
          :width="80"
        />
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'vue-lottie';
import { correctData, confettiBackgroundData, incorrectData } from '../../../assets/lottie';

export default {
  name: 'quiz-result-modal',

  props: {
    isCorrect: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      quizIconOptions: {
        animationData: null,
        loop: false,
      },
      quizResultBackgroundOptions: {
        animationData: confettiBackgroundData,
        loop: false,
      },
    };
  },

  components: {
    lottie,
  },

  beforeMount() {
    document.body.style.overflow = 'hidden';

    if (this.isCorrect) {
      this.quizIconOptions.animationData = correctData;
      return;
    }

    this.quizIconOptions.animationData = incorrectData;
  },

  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
};
</script>

<style lang="scss" scoped>
  .quiz-result-modal {
    background-color: rgba(0, 0, 0, 0.3);
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: fixed;
    z-index: 1000;

    .quiz-result-wrapper {
      position: absolute;
      top: 50%;
      margin-top: -150px;
      left: 0;
      width: 100%;

      .quiz-result-background {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: -1;
      }

      .quiz-result-content {
        margin: 100px 0 0 0;

        .quiz-result-description {
          text-align: center;
          font-weight: bold;
          font-size: 18px;
          color: #35353b;
        }
      }
    }
  }
</style>
